import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import { Footer } from '../components/FooterCta';

export const LegalLayout = ({ title, subtitle, children, testId }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="App">
      <Header />
      <main data-testid={testId}>
        <section className="relative pt-36 pb-14 lg:pt-52 md:pb-20 bg-[#0B1E44] text-white overflow-hidden">
          <div className="absolute inset-0 dotted-bg opacity-15" aria-hidden />
          <div className="relative max-w-4xl mx-auto px-5 sm:px-8">
            <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm" data-testid="legal-back-link">
              <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
            </Link>
            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight">{title}</h1>
            {subtitle && <p className="mt-4 text-white/75 text-base md:text-lg max-w-2xl">{subtitle}</p>}
          </div>
        </section>
        <section className="py-14 md:py-20 bg-[#FAF7F2]">
          <div className="max-w-4xl mx-auto px-5 sm:px-8 legal-content">{children}</div>
        </section>
      </main>
      <Footer />
    </div>
  );
};
